import { render, staticRenderFns } from "./ConfiguracaoIntegracoes.vue?vue&type=template&id=fc4cfd3e&"
import script from "./ConfiguracaoIntegracoes.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoIntegracoes.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracaoIntegracoes.vue?vue&type=style&index=0&id=fc4cfd3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports